module.exports = __webpack_public_path__ + "img/routeleaf-emblem.05e7aee3.png";